import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {Subscription,Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_toolbar } from 'app/idiomas/i18n/toolbar/toolbar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { navigation } from 'app/navigation/navigation';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

import {Router,ActivatedRoute} from "@angular/router"
import { Location } from '@angular/common';
// INTERFACES DE ENVIO Y RESPUESTA AL BACKEND
import * as backInter from 'app/auth/auth-data.model';
import { QuickPanelService } from "../quick-panel/quick-panel.service";
const moment = require('moment');
const momentTz = require('moment-timezone');

import { LoginService } from 'app/main/login/login.service';
import * as catalogos from "app/main/login/login.catalogos";
import { ToolbarService } from "./toolbar.service";
import Swal from 'sweetalert2';

@Component({
  selector     : 'toolbar',
  templateUrl  : './toolbar.component.html',
  styleUrls    : ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
  zonasUTC = [
    {instituto: 0, zona: 'Etc/Greenwich', ciudad:''},
    {instituto: 1, zona: 'America/Mexico_City', ciudad:'Ciudad de México'},  //instituto MX
    {instituto: 2, zona: 'America/El_Salvador', ciudad:''},  //instituto CAyC
    {instituto: 3, zona: 'Hongkong', ciudad:''}, //instituto HK
    {instituto: 4, zona: 'Hongkong', ciudad:''}, //instituto SGP
    {instituto: 5, zona: 'Turkey', ciudad:''}, //instituto TK
    {instituto: 6, zona: 'Hongkong', ciudad:''}, //instituto FL
    {instituto: 8, zona: 'America/Mexico_City', ciudad:'Ciudad de México'}, //instituto FL
    {instituto: 11, zona: 'Brazil/East', ciudad:''}, //instituto BR
    {instituto: 14, zona: 'America/Mexico_City', ciudad:'Ciudad de México'}, //instituto GCTI
    {instituto: 15, zona: 'Europe/Madrid', ciudad:'Madrid'}, //instituto ES
    {instituto: 18, zona: 'America/Mexico_City', ciudad:'Ciudad de México'}, //instituto AMCO
    {instituto: 19, zona: 'America/Mexico_City', ciudad:'Ciudad de México'}, //instituto AMCO
    {instituto: 22, zona: 'Hongkong', ciudad:''}, //instituto HK
  ];
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  horizontalNavbar: boolean;
  rightNavbar: boolean;
  hiddenNavbar: boolean;
  languages: any;
  navigation: any;
  selectedLanguage: any;
  userStatusOptions: any[];
  rutaimagen: string;

  datosUsuario: any;

  empresaPadre: string;
  ToolbarExterno: boolean=true;


  // Private
  private _unsubscribeAll: Subject<any>;

  //variables de autenticacion
  userIsAuthenticated = false;
  idUsuario: string;
  datosUsu: backInter.infoUsuario;
  datosEmp: backInter.infoEmpresa;

  notificaciones = 0;
  notificacionesEmpresa = 0;
  iconoNotificaciones: boolean;
  notifEmpresa:boolean;
  notificacionesGenerales:any[]=[];
  logDate:any;idiomaActual:any;
  datosAdmin: any;
  urlImagenLog= DATOS_API.urlAssets;

  authListenerSubs: Subscription;
  form = this._formBuilder.group({
    colorTheme      : new FormControl(),
    customScrollbars: new FormControl(),
    layout          : this._formBuilder.group({
      style    : new FormControl(),
      width    : new FormControl(),
      navbar   : this._formBuilder.group({
        primaryBackground  : new FormControl(),
        secondaryBackground: new FormControl(),
        folded             : new FormControl(),
        hidden             : new FormControl(),
        position           : new FormControl(),
        variant            : new FormControl()
      }),
      toolbar  : this._formBuilder.group({
        background           : new FormControl(),
        customBackgroundColor: new FormControl(),
        hidden               : new FormControl(),
        position             : new FormControl()
      }),
      footer   : this._formBuilder.group({
        background           : new FormControl(),
        customBackgroundColor: new FormControl(),
        hidden               : new FormControl(),
        position             : new FormControl()
      }),
      sidepanel: this._formBuilder.group({
        hidden  : new FormControl(),
        position: new FormControl()
      })
    })
  });
  jsonsConfiguracion: any = {};
  dominiosEspeciales = catalogos.dominiosEspeciales;
  brokersEspeciales = catalogos.brokersEspeciales;

  showProfile:boolean=false;
  nivelesBotonPerfil = [1, 2, 3, 5, 8, 4, 10, 12, 13, 14, 15, 18];

  /**
  * Constructor
  *
  * @param {FuseConfigService} _fuseConfigService
  * @param {FuseSidebarService} _fuseSidebarService
  * @param {TranslateService} _translateService
  */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private _translateService: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private http:HttpClient,
    private qps: QuickPanelService,
    private router: Router,
    private loginService: LoginService,
    private _formBuilder: FormBuilder,
    private tbs: ToolbarService,
    private location: Location
  )
  {
    // Set the defaults
    this.idiomaActual = this._translateService.currentLang;
    this.userStatusOptions = [
      {
        title: 'Online',
        icon : 'icon-checkbox-marked-circle',
        color: '#4CAF50'
      },
      {
        title: 'Away',
        icon : 'icon-clock',
        color: '#FFC107'
      },
      {
        title: 'Do not Disturb',
        icon : 'icon-minus-circle',
        color: '#F44336'
      },
      {
        title: 'Invisible',
        icon : 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD'
      },
      {
        title: 'Offline',
        icon : 'icon-checkbox-blank-circle-outline',
        color: '#616161'
      }
    ];

    this.languages = [
      {
        id   : 'en',
        title: 'English',
        flag : 'us',
        short: 'en'
      },
      {
        id   : 'es',
        title: 'Español',
        flag : 'es',
        short: 'es'
      },
      {
        id   : 'tr',
        title: 'Turkish',
        flag : 'tr',
        short: 'tr'
      },
      {
        id   : 'zh1',
        title: 'Traditional Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'zh2',
        title: 'Simplified Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'pt',
        title: 'Portuguese',
        flag : 'pt',
        short: 'pt'
      },
      {
        id   : 'de',
        title: 'Alemán',
        flag : 'de',
        short: 'de'
      },
      {
        id   : 'nl',
        title: 'Holandés',
        flag : 'nl',
        short: 'nl'
      }

    ];

    this.navigation = navigation;
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_toolbar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // orden de actualizacion de botones del wizard
    this.authService.mensajeActual.subscribe( (resu) => {
      if(resu == "100"){
        // console.log("por subscribe");
        let datosUsuario = JSON.parse(localStorage.getItem('userData'));
        if(datosUsuario.level != 2 && datosUsuario.level != 3){
          this.getImagenLogo();
        }
      }
    });

    //orden de obtener notificaciones
    this.qps.actualizaNotif.subscribe( (respuesta) => {
      if(respuesta){
        this.getNotificaciones();
      }
    });

    this.qps.actualizaHistorialNotif.subscribe( (respuesta) => {
      console.log('respuesta',respuesta);

      if(respuesta){
        if (localStorage.getItem('companyID')!='0') {
          console.log("entro como empresa ");
          this.getNotificacionesEmpresaId('0');
        }else{
          console.log("no hace nada ");

        }
      }
    });
    //orden de ocultar icono notificaciones
    this.qps.muestraIcoNot.subscribe( (respuesta) => {
      console.log('mostrar icono',respuesta);

      this.iconoNotificaciones = respuesta;
    });

    if(localStorage.getItem("userBypass")){
      this.datosAdmin = JSON.parse(localStorage.getItem('userBypass'));
    }
    else{
      this.datosAdmin = undefined;
    }

    /// VALIDACION DE DOMINIO PARA PORTAL DE CONTEOS EXTERNO
    const conteos_ruta = this.location.path().split('/');
    if(this.authService.getIsAuth() || conteos_ruta.includes('counting')){  /// 'counting' = ruta del portal externo
      console.log("ES AUTH");
      this.evaluaConfigCustom();
    }
    // console.log("datosAdmin:",this.datosAdmin);
    // this._translateService.onLangChange.subscribe(() => { this.cambioIdiomaConfiguracion(this._translateService.currentLang,2); });
    this.authService.mensajeActualQuick.subscribe( (resu:any) => {
      console.log('resu',resu);
      let actualizar:any=resu.actua;
      let nivel:any=resu.nivelNotif;
      if(actualizar== "100"){
        console.log("entro este  visne ajuuuuuaaaaaaa");
        switch (nivel) {
          case 1:
          console.log("No se actualiza nada ");
          break;
          case 2:
          this.getNotificacionesEmpresaId(nivel);
          break;
          case 3:
          console.log("entro nivel 3");

          this.getNotificacionesEmpresaId(nivel);
          this.playAudio();
          // document.getElementById('icon_class').style.color = "red";
          break;

          default:

          break;
        }
      }
    });
if (localStorage.getItem('ToolbarExterno')) {
  console.log('Requerimientos externo');
  this.ToolbarExterno=false;
}else{
  this.ToolbarExterno=true;
}

  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  evaluaConfigCustom(){
    console.log("EVALUARÁ CONFIGURACION CUSTOM");

    let brokerActual = localStorage.getItem('instituto_id') != undefined ? localStorage.getItem('instituto_id') : this.authService.getInstituto();
    if(brokerActual == '0'){
      brokerActual = localStorage.getItem('tmpBroker');
      this.configuracionInicial(brokerActual);
    } else{
      if(brokerActual != localStorage.getItem('tmpBroker')){
        localStorage.setItem('tmpBroker', brokerActual);
        this.loginService.getFlag(parseInt(brokerActual)).subscribe((respuesta:any) => {
          console.log("getFlagLogin:",respuesta);
          if(respuesta.success){
            if(respuesta.flagStatus.flag){
              localStorage.setItem('customConfig',"true");
              this.configuracionInicial(brokerActual);
            }
          }
        });
      } else{
        localStorage.removeItem("tmpBroker");
        this.configuracionInicial(brokerActual);
      }
    }
  }

  configuracionInicial(brokerActual:string){
    console.log("COLOCARA CONFIG INICIAL");

    let banderaCustConf: boolean = (localStorage.getItem('customConfig') == "true");
    if(banderaCustConf){
      this.setConfiguracionCustom(parseInt(brokerActual));
      this.tbs.enviaNavbar({status:false});
    } else{
      this.detectaDominioEspecial();
    }
  }

  setConfiguracionCustom(brokerActual:number){
    console.log("SETEARA CONFIG CUSTOM");

    this.loginService.getJsons(brokerActual).subscribe((respuesta:any) => {
      console.log("getJsonsLogin:",respuesta);
      if(respuesta.success){
        respuesta.jsonCGO.forEach(json => {
          if(!this.jsonsConfiguracion[json.lang]){
            this.jsonsConfiguracion[json.lang] = json;
          }
        });
        this.cambioIdiomaConfiguracion(this._translateService.currentLang,1);
      }
    });
  }

  cambioIdiomaConfiguracion(idioma:string, via:number){
    console.log("cambioConfIdioma, via:",via);
    let referenciaJson = this.jsonsConfiguracion[idioma].home;
    console.log("referenciaJson, referenciaJson:",referenciaJson);
    if(referenciaJson != undefined){
      this.tbs.enviaNavbar({status:true, jsons:referenciaJson});
      if(referenciaJson.generics.theme != ""){
        this.form.controls['colorTheme'].setValue(referenciaJson.generics.theme);
      }
      if (referenciaJson.loaderGif.image!="") {
        localStorage.setItem('urlGifBroker',referenciaJson.loaderGif.image);
      }else{
        localStorage.setItem('urlGifBroker','https://app04.culturalgo.com/assetsCGO5/platform/img/loading.gif');
      }
    }
  }

  detectaDominioEspecial(){
    let [dominio] = (window.location.href).split('#');
    let dominioEncontrado: any;
    let BreakException = {};
    try {
      this.dominiosEspeciales.forEach(domEsp => {
        if(dominio.includes(domEsp.dominio)){
          dominioEncontrado = domEsp;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    if(dominioEncontrado){
      console.log("dominio coincidente:",dominioEncontrado);
      setTimeout(() => {
        this.form.controls['colorTheme'].setValue(dominioEncontrado.tema);
      }, 400);
    } else{
      console.log("no se encontro dominio especial, actual:",dominio);
      if (localStorage.getItem('tipoBroker')){
        let datosParametro = this.brokersEspeciales.find(item => item.urlParam == localStorage.getItem('tipoBroker'));
        // console.log("datosParametro coincidente:",datosParametro);
        setTimeout(() => {
          this.form.controls['colorTheme'].setValue(datosParametro.tema);
        }, 400);
      }
    }
  }

  getDatosSide(){
    let esperaDatos = setInterval( () => {
      if(this.authService.getIsAuth())
      {
        if(this.authService.getInfoUsuario() != null){
          if(this.datosUsu == null){
            if(localStorage.getItem('empresaPadre')){
              // this.empresaPadre = localStorage.getItem('empresaPadre');
              this.getInfoEmpresa(localStorage.getItem('empresaPadre'));
              this.getImagenLogo(localStorage.getItem('empresaPadre'));
            }
            else this.empresaPadre = null;
            // console.log("entro al caso is auth");
            //BLOQUE INICIAL AUTENTICACION
            this.userIsAuthenticated = this.authService.getIsAuth();
            this.idUsuario = this.authService.getIdUsuario();
            this.datosUsu = this.authService.getInfoUsuario();
            // console.log(this.authService.getInfoUsuario());
            this.showProfile=false;
            if(this.nivelesBotonPerfil.includes(this.datosUsu.level)){
              this.showProfile=true;
              const nivelesSinInfoIzq = [2, 3];
              if(!nivelesSinInfoIzq.includes(this.datosUsu.level)){
                this.getInfoEmpresa();
                console.log("por nivel",this.datosUsu.level);
                this.getImagenLogo();
              }
            }
            else
            console.log("nivel:",this.datosUsu.level);

            this.setInfoCards(this.datosUsu.level);
            clearInterval(esperaDatos);
          }
        }

      }
    }, 0);
  }

  getInfoEmpresa(empresaPadre?:string){
    let idEmpresa: string;
    if(empresaPadre){
      idEmpresa = empresaPadre;
    }
    else idEmpresa = this.datosUsu.empresaId;
    this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa)
    .subscribe((data:backInter.infoEmpresa) => {
      this.datosEmp = data;
      this.setInfoCards();
      // console.log(this.datosEmp);
    }, error  => {
      console.log("error");
    });
  }

  setInfoCards(origen?:number){
    // console.log("entro a cards");
    let nomImg: string;
    if(!origen)
    {
      if(this.datosEmp){
        if (!this.datosEmp.data.imagen) nomImg = 'empIco';
        else nomImg = this.datosEmp.data.imagen;
        this.datosUsuario = {
          'nombre': this.datosEmp.data.nombreEmpresa,
          'email': this.datosUsu.user,
          'avatar': nomImg
        };
      }
    }
    else{
      let nombre = "";
      let imgNom = "";
      let logoInstituto:string=localStorage.getItem('instituto_id');
      switch(origen){
        case 2:
         nombre = "Admin User";
         switch (logoInstituto) {
           case '14':
             imgNom = 'gcti';
             break;
           case '18':
           imgNom = 'amco';
             break;
           case '19':
           imgNom = 'innmotion';
             break;

           default:
             imgNom = 'GPTW';
             break;
         }
        break;
        case 3: case 4: nombre = "ITBM"; imgNom = nombre; break;
        case 7: nombre = "COVID Results"; imgNom = 'CGO'; break;
        case 11: nombre = "empIco"; imgNom = nombre;
        console.log("entro en usuario izzi");
        break;
      };
      this.datosUsuario = {
        'nombre': nombre,
        'email': this.datosUsu.user,
        'avatar': imgNom.toLowerCase()
      };
      if (logoInstituto=='19') {
        this.rutaimagen = this.urlImagenLog+"platform/avatars/"+imgNom.toLowerCase()+".png";
      }else{
        this.rutaimagen = this.urlImagenLog+"platform/avatars/"+imgNom.toLowerCase()+".jpg";
      }
      console.log("rutaimagen: ", this.rutaimagen);

    }

  }
  /**
  * On init
  */

  ngOnInit(): void
  {
    this.logDate= localStorage.getItem('date_log');
    this.getDatosSide();

    this.datosUsuario = {
      'nombre': '',
      'email': '',
      'avatar': 'empIco'
    };
    // Subscribe to the config changes
    this._fuseConfigService.config
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((settings) => {
      this.horizontalNavbar = settings.layout.navbar.position === 'top';
      this.rightNavbar = settings.layout.navbar.position === 'right';
      this.hiddenNavbar = settings.layout.navbar.hidden === true;
      this.form.setValue(settings, {emitEvent: false});
    });

    this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      // Update the config
      console.log("cambiara tema:",config);
      this._fuseConfigService.config = config;
    });

    // Set the selected language from default languages
    this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});

    if(this.authService.getIsAuth()){
      setTimeout(() => {
        this.setLocalidad();
      }, 2000);
    }
    this.authListenerSubs = this.authService.getAuthStatusListener().subscribe((isAuthenticated: any) => {
      // console.log("es autenticado: ",isAuthenticated);
      if(isAuthenticated.status == true){
        setTimeout(() => {
          this.setLocalidad();
        }, 2000);
      }
    });

  }
  setLocalidad(){
    switch(localStorage.getItem('instituto_id')){
      case 'MX': this.city_name='TOOLBAR.CITIES.1';    this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(1);break;
      case 'CAyC': this.city_name='TOOLBAR.CITIES.2';  this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(2); break;
      case 'HK': this.city_name='TOOLBAR.CITIES.3';    this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(3); break;
      case 'SGP': this.city_name='TOOLBAR.CITIES.4';   this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(4); break;
      case 'TK': this.city_name='TOOLBAR.CITIES.5';    this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(5); break;
      case 'FL': this.city_name='TOOLBAR.CITIES.6';    this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(6); break;
      case 'IZZI': this.city_name='TOOLBAR.CITIES.8';  this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(8); break;
      case 'BR': this.city_name='TOOLBAR.CITIES.11';   this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(11); break;
      case 'GCTI': this.city_name='TOOLBAR.CITIES.14';   this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(14); break;
      case 'ES': this.city_name='TOOLBAR.CITIES.15';   this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(15); break;
      // case 'HK': this.city_name='TOOLBAR.CITIES.3';    this.city_name='TOOLBAR.CITIES.3'; this.validoInstitutoID(22); break;
      default: break;
    }
    this.calculoOffsetPipe();
  }
  validoInstitutoID(instituto_id){
    localStorage.setItem('instituto_id',''+instituto_id)
  }
  city_name:any;
  calculoOffsetPipe(){
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("Indice zona "+this.indiceZona);
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    if(localStorage.getItem('nameCity')){
      this.city_name = localStorage.getItem('nameCity');
    }
    else{
      this.city_name='TOOLBAR.CITIES.'+localStorage.getItem('instituto_id');
    }
    console.log("offsetPipe:",this.offsetPipe);
    console.log("city_name:",this.city_name);
  }

  /**
  * On destroy
  */
  ngOnDestroy(): void
  {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  cerrarSesion() {
    // localStorage.clear();    //NO BORRAR EL LOCAL STORAGE!!!! Si hace falta borrar variables, se borran en el auth.service
    // setInterval(() => window.location.reload(), 1000);
    Swal.fire({
      title: this._translateService.instant('TOOLBAR.LOGOUT_MODAL.TEXTO'),
      icon: 'question',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: this._translateService.instant('TOOLBAR.LOGOUT_MODAL.SI'),
      cancelButtonText: this._translateService.instant('TOOLBAR.LOGOUT_MODAL.NO')
    }).then((result) => {
      if (result.value) {
        this.authService.logout_log();
        this.authService.logout();
      }
    });
  }
  myprofile(){
    this.router.navigate(['my_profile']);
  }

  /**
  * Toggle sidebar open
  *
  * @param key
  */
  toggleSidebarOpen(key): void
  {
    console.log(key);

    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  /**
  * Search
  *
  * @param value
  */
  search(value): void
  {
    // Do your search here...
    console.log(value);
  }

  /**
  * Set the language
  *
  * @param lang
  */
  setLanguage(lang): void
  {
    // Set the selected language for the toolbar
    this.selectedLanguage = lang;

    // Use the selected language for translations
    this._translateService.use(lang.id);
    if(localStorage.getItem('customConfig')){
      console.log('**error A-721**-------------- numero 1');
      this.cambioIdiomaConfiguracion(this._translateService.currentLang,2);
    }
  }
  getImagenLogo(empresaPadre?:string){
    this.authService.getLogo(empresaPadre).subscribe( (data: backInter.getLogoEmpresa) => {
      // console.log(data);
      if(data.message=="702"){
        let url = DATOS_API.urlLogos.split(":");
        this.rutaimagen= url[1]+"/surveyadministrator/backend/"+data.rutaArchivo;
      }
      else if(data.message=="logos_getLogo_1"){
        this.rutaimagen="assets/images/avatars/empIco.jpg";
        // console.log(data);
      }

    });
  }

  getNotificaciones(){
    this.notificaciones = 0;
    this.qps.getNotificaciones().subscribe((respuesta:any) => {
      this.notifEmpresa=false;
      console.log("getNotifs:",respuesta);
      if(respuesta.success){
        respuesta.notificacionGral.forEach(element => {
          if(!element.status){
            this.notificaciones++;
          }
        });
      }
    });
  }

  getNotificacionesEmpresaId(nivel){
    console.log("lamando a llamar",nivel);
    this.notificacionesGenerales=[];
    this.notificacionesEmpresa=0;
    console.log('localStorage companyID',localStorage.getItem('companyID'));

    if (localStorage.getItem('companyID')!='0') {
      this.qps.getNotificacionesEmpresaID(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
        this.notifEmpresa=true;
        console.log("getNotifsProductoId:",respuesta);
        respuesta.historial.forEach(tipProduct => {
          if (tipProduct.historial.length>0) {
            tipProduct.historial.forEach(historialProduc => {
              historialProduc.productoId=tipProduct.productoId;
              historialProduc.tipoProducto=tipProduct.tipoProducto;
              historialProduc.fechaProducto=tipProduct.fechaProducto;
              this.notificacionesGenerales.push(historialProduc);
            });

          }
        });
        if (nivel==2|| nivel==3) {
          console.log("entro nivel",nivel);
          this.notificacionesEmpresa=0;
          this.notificacionesGenerales.forEach(totalNotif => {

            if (totalNotif.vivo==1 && totalNotif.levelNotification!=1) {
              this.notificacionesEmpresa++;
            }
          });

        }else{
          console.log('No entro.');

        }
        console.log('notificacionesEmpresa ',this.notificacionesEmpresa);

      });


    }else{
      console.log('ITBM---- GPTW--ADMIN',localStorage.getItem('companyID'));

    }
  }


  playAudio() {
    console.log('encontro un audio');
    const audio = new Audio('assets/notif.mp3');
    audio.play();
    // document.getElementById('icon_class').style.color = "red";
  }
}
